"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;
// import ViewSortBar from '@quixeltools/quixel-ui-library/dist/components/megascans/library/ViewSortBar';


var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _redial = require("redial");

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _reactRedux = require("react-redux");

var _glamor = require("glamor");

var _components = require("components");

var _AssetsGrid = require("components/AssetsGrid/AssetsGrid");

var _AssetsGrid2 = _interopRequireDefault(_AssetsGrid);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _utils = require("../../utils");

var _libraryNav = require("utils/libraryNav");

var _LibraryLayout = require("@quixeltools/quixel-ui-library/dist/components/megascans/library/LibraryLayout");

var _LibraryLayout2 = _interopRequireDefault(_LibraryLayout);

var _LibraryFeaturedItem = require("@quixeltools/quixel-ui-library/dist/components/megascans/library/LibraryFeaturedItem");

var _LibraryFeaturedItem2 = _interopRequireDefault(_LibraryFeaturedItem);

var _ReferenceImagePopup = require("@quixeltools/quixel-ui-library/dist/components/megascans/library/ReferenceImagePopup");

var _ReferenceImagePopup2 = _interopRequireDefault(_ReferenceImagePopup);

var _Slider = require("@quixeltools/quixel-ui-library/dist/components/common/website/Slider");

var _Slider2 = _interopRequireDefault(_Slider);

var _facets = require("redux/modules/facets");

var _assets = require("redux/modules/assets");

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Library = (_dec = (0, _redial.provideHooks)({
  fetch: function fetch(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        params = _ref.params,
        query = _ref.query;

    var state = getState();
    var returnTo = query.returnTo;

    if (returnTo && returnTo.indexOf("assets") > -1) {
      var id = returnTo.split("/")[2];
      var asset = null;
      if (state && state.assets && state.assets.fullAssets && state.assets.fullAssets.find) {
        asset = state.assets.fullAssets.find(function (a) {
          return a.id === id;
        });
      }
      if (asset) {
        return dispatch(function () {});
      }
      if (!(0, _assets.hasFullAsset)(getState(), id)) {
        return dispatch((0, _assets.loadFullAsset)(id));
      }
    }
  },
  defer: function defer(_ref2) {
    var _ref2$store = _ref2.store,
        dispatch = _ref2$store.dispatch,
        getState = _ref2$store.getState,
        query = _ref2.query;
    var view = query.view,
        type = query.type,
        biome = query.biome,
        region = query.region,
        category = query.category,
        subCategory = query.subCategory;

    var state = getState();

    if (state.assets && state.assets.initialized) {
      //already fetched
      return null;
    } else {
      var isArchviz = state.user && state.user.subscription && state.user.subscription.isArchViz || state.routing.locationBeforeTransitions.pathname.indexOf("library/archviz") > -1;

      var favorites = dispatch((0, _assets.getFavorites)());
      var acquired = dispatch((0, _assets.getAcquiredAssets)());
      var categoryTree = dispatch((0, _assets.getCategoryAssetCount)(isArchviz));
      var featured = dispatch((0, _assets.getFeatured)());
      return _bluebird2.default.all([favorites, acquired, categoryTree, featured]);
    }
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    acquired: state.assets.acquired,
    favorites: state.assets.favorites,
    assets: state.assets.assets,
    assetOptions: state.assets.options,
    packs: state.packs.packs,
    collections: state.packs.packs,
    facets: state.facets.facets,
    user: state.user,
    loggedIn: state.auth.loggedIn,
    notifications: state.notifications,
    categoryTree: state.assets.categoryTree,
    ads: state.assets.featured,
    isArchviz: state.assets.isArchviz,
    algoliaAssets: state.assets.assets,
    freeAssetDrops: state.assets.freeAssetDrops,
    fullAssets: state.assets.fullAssets
  };
}, { getFavorites: _assets.getFavorites, getAcquiredAssets: _assets.getAcquiredAssets, getCategoryAssetCount: _assets.getCategoryAssetCount, setIsArchviz: _assets.setIsArchviz }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Library, _Component);

  function Library(props) {
    (0, _classCallCheck3.default)(this, Library);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Library.__proto__ || (0, _getPrototypeOf2.default)(Library)).call(this, props));

    _this.onClickHandlerForReferenceImages = _this.onClickHandlerForReferenceImages.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Library, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getCategoryAssetCount(this.props.location.pathname.indexOf("library/archviz") > -1 || this.props.user && this.props.user.subscription && this.props.user.subscription.isArchViz);
      var firstSubscribe = window.localStorage.getItem("firstSubscribe");
      if (firstSubscribe === "true" && (this.props.location.pathname.indexOf("library/archviz/latest") > -1 || this.props.location.pathname.indexOf("library/latest") > -1)) {
        window.localStorage.setItem("firstSubscribe", false);
        var dialogs = this.context.dialogs;
        setTimeout(function () {
          dialogs.custom(_react2.default.createElement(_components.TrialPopup, { title: "Welcome to the Subscription", custom: true }));
        }, 3000);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.collections !== this.props.collections) {
        var location = this.props.location;

        if (location.query.returnTo) {
          this.context.router.push({
            pathname: location.query.returnTo,
            state: { modal: true }
          });
        }
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.isArchviz && this.props.isArchviz !== nextProps.isArchviz) {
        this.props.getCategoryAssetCount(true);
      }
      if (!nextProps.isArchviz && this.props.isArchviz !== nextProps.isArchviz) {
        if (this.props.loggedIn && !this.props.user.subscription || this.props.loggedIn && this.props.user.subscription && !this.props.user.subscription.isArchViz || !this.props.loggedIn) {
          this.props.getCategoryAssetCount(false);
        }
      }

      if (this.props.user.loaded !== nextProps.user.loaded) {
        var isArchviz = nextProps.user && nextProps.user.subscription && nextProps.user.subscription.isArchViz || false;

        //in case archviz vas signed in, reload archviz assets
        this.props.getCategoryAssetCount(isArchviz);
        this.props.getFavorites();
        this.props.getAcquiredAssets();
      }
      // store the location key before a modal appears
      if (nextProps.behindAModal) {
        this.previousLocation = this.props.location;
      }

      // update if the route before the modal opened is not the same after it closed
      if (this.props.behindAModal && !nextProps.behindAModal && (nextProps.location.pathname !== this.previousLocation.pathname || nextProps.location.search !== this.previousLocation.search)) {
        return true;
      }

      return !nextProps.behindAModal && !this.props.behindAModal || this.props.loggedIn !== nextProps.loggedIn || this.props.user.loaded !== nextProps.user.loaded;
    }
  }, {
    key: "onClickHandlerForReferenceImages",
    value: function onClickHandlerForReferenceImages(ev) {
      ev.stopPropagation();
      ev.preventDefault();

      var cf = function cf(path) {
        var arr = path.split("/");
        arr[0] = "https://d3uwib8iif8w1p.cloudfront.net/megascans";
        return arr.join("/");
      };

      var _props = this.props,
          collections = _props.collections,
          params = _props.params;

      var selectedCollection = _ramda2.default.find(_ramda2.default.propEq("id", params.collectionId))(collections);
      if (selectedCollection && selectedCollection.presentation.referenceImages) this.context.dialogs.custom(_react2.default.createElement(_ReferenceImagePopup2.default, {
        images: selectedCollection.presentation.referenceImages.map(function (link) {
          return cf(link);
        }),
        fullScreenImages: selectedCollection.presentation.referenceImages.map(function (link) {
          return cf(link);
        })
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          fullAssets = _props2.fullAssets,
          algoliaAssets = _props2.algoliaAssets,
          freeAssetDrops = _props2.freeAssetDrops,
          assetOptions = _props2.assetOptions,
          packs = _props2.packs,
          collections = _props2.collections,
          facets = _props2.facets,
          loggedIn = _props2.loggedIn,
          loading = _props2.loading,
          appendLoading = _props2.appendLoading,
          loadNotFound = _props2.loadNotFound,
          params = _props2.params,
          addToFavorites = _props2.addToFavorites,
          removeFromFavorites = _props2.removeFromFavorites,
          notifications = _props2.notifications,
          acquired = _props2.acquired,
          favorites = _props2.favorites,
          categoryTree = _props2.categoryTree,
          ads = _props2.ads,
          user = _props2.user;

      var isArchviz = this.props.location.pathname.indexOf("library/archviz") > -1 || this.props.user && this.props.user.subscription && this.props.user.subscription.isArchViz;

      this.props.setIsArchviz(isArchviz);

      var sidebar = _react2.default.createElement(_components.LibraryNavSidebar, {
        packs: packs,
        facets: facets,
        categoryTree: categoryTree,
        loggedIn: loggedIn,
        acquired: acquired.length,
        favorites: favorites.length,
        user: user
      });

      var searchbar = _react2.default.createElement(_components.SearchBar, this.props.location);

      var banner = _react2.default.createElement(_components.LibraryTopBanner, null);

      // const sortViewBar = shouldShowSortViewBar ? (
      //   <ViewSortBar
      //     sortSelectProps={{
      //       options: [
      //         { name: 'Featured First', value: 'default' },
      //         { name: 'Latest First', value: 'latest' },
      //         { name: 'Sort by Hue', value: 'hue' },
      //         { name: 'Sort by Brightness', value: 'brightness' },
      //       ],
      //       value: assetOptions.sort || 'default',
      //       onChange: dropdownChangeHandler(router, query, 'sort'),
      //     }}
      //   />
      // ) : null;
      var slider = params.view === "latest" ? _react2.default.createElement(
        _Slider2.default,
        { delay: "7" },
        _ramda2.default.map(function (ad) {
          return ad.url ? _react2.default.createElement(_LibraryFeaturedItem2.default, {
            key: ad.image,
            imgUrl: ad.image,
            smallHeading: ad.label && _ramda2.default.toUpper(ad.label),
            title: ad.title,
            body: ad.description,
            linkTitle: ad.buttonLabel,
            linkHref: ad.url,
            secondaryLinkTitle: ad.linkLabel,
            secondaryLinkTo: ad.linkUrl,
            newWindow: ad.linkActionTarget === "_blank"
          }) : _react2.default.createElement(_LibraryFeaturedItem2.default, {
            key: ad.image,
            imgUrl: ad.image,
            smallHeading: _ramda2.default.toUpper(ad.label),
            title: ad.title,
            body: ad.description,
            linkTitle: ad.buttonLabel,
            linkTo: ad.tags ? isArchviz ? "/megascans/library/archviz?search=" + ad.tags : "/megascans/library?search=" + ad.tags : isArchviz ? "/megascans/library/archviz/packs/" + ad.pack : "/megascans/library/packs/" + ad.pack,
            secondaryLinkTitle: ad.linkLabel,
            secondaryLinkTo: ad.linkUrl,
            newWindow: ad.linkActionTarget === "_blank"
          });
        }, ads)
      ) : false;

      var cf = function cf(path) {
        var arr = path.split("/");
        arr[0] = "https://d3uwib8iif8w1p.cloudfront.net/megascans";
        return arr.join("/");
      };

      var selectedPack = _ramda2.default.find(_ramda2.default.propEq("id", params.pack))(packs);
      var packHeader = selectedPack !== undefined ? _react2.default.createElement(_LibraryFeaturedItem2.default, {
        imgUrl: cf(selectedPack.presentation.coverImages[0]),
        title: selectedPack.name,
        body: selectedPack.presentation.subtitle
      }) : false;

      var selectedCollection = _ramda2.default.find(_ramda2.default.propEq("id", params.collectionId))(collections);

      var collectionHeader = selectedCollection !== undefined ? _react2.default.createElement(_LibraryFeaturedItem2.default, {
        imgUrl: cf(selectedCollection.presentation.coverImages[0]),
        title: selectedCollection.name,
        body: selectedCollection.presentation.subtitle,
        secondaryLinkTitle: selectedCollection.presentation.referenceImages && selectedCollection.presentation.referenceImages.length > 0 && "View Reference Images",
        onClickSecondaryHandler: selectedCollection.presentation.referenceImages && selectedCollection.presentation.referenceImages.length > 0 && this.onClickHandlerForReferenceImages
      }) : false;

      var returnTo = this.props.location.query.returnTo;


      var thumbImage = "https://cdn.quixel.com/megascans/apps/mixer_integration.jpg";

      if (returnTo && returnTo.indexOf("assets") > -1) {
        var assetId = returnTo.split("/")[2];

        var asset = fullAssets[assetId];
        var aAssets = algoliaAssets && algoliaAssets.toArray && algoliaAssets.toArray();
        var algoliaAsset = aAssets && aAssets.find && aAssets.find(function (a) {
          return a.id === assetId;
        });
        if (!algoliaAsset) {
          algoliaAsset = freeAssetDrops && freeAssetDrops.find && freeAssetDrops.find(function (a) {
            return a.id === assetId;
          });
        }

        asset = asset || algoliaAsset;
        var assetType = asset.type || asset.categories[0];
        var assetName = (0, _utils.capitalize)((0, _utils.getAssetName)(asset));

        if (asset.previews.images && asset.previews.images[0] && asset.previews.images[0].tags) {
          if (__SERVER__) {
            var siteImage = (0, _utils.pickPreviewsForAsset)(assetType, 800, 800, asset.previews.images).retArray[0];
            return _react2.default.createElement(
              _components.AppSideEffects,
              { documentTitle: assetName, documentImage: siteImage },
              _react2.default.createElement("div", null)
            );
          }
        }
      }

      // const menu = (
      //   <SiteHeaderMenu />
      // );

      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "Megascans Library",
          documentImage: thumbImage
        },
        _react2.default.createElement(_LibraryLayout2.default, {
          sidebar: sidebar,
          searchbar: searchbar
          // sortViewBar={sortViewBar}
          // menu={menu}
          , slider: slider,
          packHeader: packHeader,
          collectionHeader: collectionHeader,
          grid: this.props.children,
          showBanner: this.props.showBanner,
          banner: banner
        })
      );
    }
  }]);
  return Library;
}(_react.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = Library;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Library/Library.jsx
// module id = 2890
// module chunks = 0